import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { Bot, Star, Users, Headphones } from "lucide-react";
import chatbotBanner from "../../../images/chatbotbg.png";

const trustMetrics = [
  { value: 500, suffix: "+", label: "Chatbots Delivered", icon: Bot },
  { value: 100, suffix: "+", label: "Happy Clients", icon: Users },
  { value: 24, suffix: "/7", label: "AI Support", icon: Headphones },
  { value: 4.9, suffix: "", label: "Client Rating", icon: Star, decimal: true },
];

const ChatBotHero: React.FC = () => (
  <section className="cbot-hero" aria-labelledby="cbot-hero-title">
    <div className="cbot-hero__mesh" aria-hidden="true" />
    <div className="cbot-particles" aria-hidden="true">
      {Array.from({ length: 18 }, (_, i) => (
        <span key={i} />
      ))}
    </div>

    <div className="cbot-container cbot-hero__grid">
      <motion.div
        className="cbot-hero__content"
        initial={{ opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <span className="cbot-eyebrow">
          <Bot size={14} aria-hidden="true" />
          AI-Powered Chatbot Solutions
        </span>

        <h1 id="cbot-hero-title">
          Intelligent Chatbots That{" "}
          <span className="cbot-gradient-text">Automate Support</span> &amp;{" "}
          <span className="cbot-gradient-text">Drive Growth</span>
        </h1>

        <p>
          Build smart AI chatbots that provide instant customer support, generate
          leads, automate workflows, and improve customer engagement 24/7.
        </p>

        <div className="cbot-hero__actions">
          <Link className="cbot-btn cbot-btn--primary" to="/contact">
            Get Free Consultation
            <ArrowIcon />
          </Link>
          <Link className="cbot-btn cbot-btn--ghost" to="/contact">
            Watch Demo
            <ArrowIcon />
          </Link>
        </div>

        <div className="cbot-hero__metrics">
          {trustMetrics.map((metric) => {
            const Icon = metric.icon;
            return (
              <div className="cbot-metric" key={metric.label}>
                <span className="cbot-metric__icon" aria-hidden="true">
                  <Icon size={18} />
                </span>
                <strong>
                  {metric.decimal ? (
                    <CountUp end={metric.value} decimals={1} duration={2.2} enableScrollSpy scrollSpyOnce />
                  ) : (
                    <CountUp end={metric.value} duration={2.2} enableScrollSpy scrollSpyOnce />
                  )}
                  {metric.suffix}
                </strong>
                <span>{metric.label}</span>
              </div>
            );
          })}
        </div>
      </motion.div>

      <div className="cbot-hero__visual">
        <motion.div
          className="cbot-hero__banner-wrap"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15, ease: "easeOut" }}
        >
          <img
            src={chatbotBanner}
            alt="AI chatbot with mobile assistant, messaging integrations, and analytics dashboard"
            className="cbot-hero__banner"
          />
        </motion.div>
      </div>
    </div>
  </section>
);

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M3 8h10M9 4l4 4-4 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChatBotHero;
